export class QuizAnswer {
  id!: string;
  text!: string;
  isSelected: boolean = false;
  isCorrect: boolean | null = null;
  constructor(data: any) {
    this.id = data.answerUid;
    this.text = data.answerText;
    this.isCorrect = data.isCorrect;
  }
}
